<div class="container">
    <h2 class="title">{{ 'sidebar.menu.settings.label' | translate }}</h2>
    <div class="settings-container">
        <div class="language-container">
            <app-channel-select-input
                name="language"
                label="settings-language"
                [itemList]="LANGUAGE_OPTIONS"
                [value]="selectedLanguage"
                (inputChange)="languageSelect($event)">
            </app-channel-select-input>
        </div>
    </div>

    <div class="input-wrapper" *ngIf="isRunningInElectron">
        <div class="system-title">
            {{ 'settings.electron.title' | translate }}
        </div>
        <div class="right-side-container">
            <div class="system-button" (click)="toggleSize()">
                {{ 'settings.electron.toggle' | translate }}
            </div>
            <div class="system-button" (click)="closeWindow()">
                {{ 'settings.electron.close' | translate }}
            </div>
            <div class="system-button" (click)="reboot()">
                {{ 'settings.electron.reboot' | translate }}
            </div>
            <div class="system-button" (click)="syncDatabase()">
                {{ 'settings.electron.sync' | translate }}
            </div>
        </div>
    </div>
</div>

<ng-container *ngIf="isLoading">
    <div class="loading-container">
        <app-loading-spinner title="dlg.syncing"></app-loading-spinner>
    </div>
</ng-container>
